import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ isTransparent = false }: { isTransparent?: boolean }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('en') ? 'en' : 'mn';

  const toggle = () => {
    i18n.changeLanguage(currentLang === 'mn' ? 'en' : 'mn');
  };

  return (
    <button
      onClick={toggle}
      className={`px-3 py-1.5 text-xs font-bold rounded-full border transition-all duration-200 ${
        isTransparent
          ? 'border-white/20 bg-white/10 text-white hover:bg-white/20'
          : 'border-neutral-200 bg-neutral-100 text-neutral-700 hover:bg-neutral-200'
      }`}
    >
      {currentLang === 'mn' ? 'EN' : 'MN'}
    </button>
  );
};

export default LanguageSwitcher;
